import { createUseStyles } from '../../theme/theming';

const usePhotoGalleryStyles = createUseStyles((theme) => {
  return {
    container: {
      background: theme?.palette?.background?.default,
      padding: ({ isMobile, cardsCount } = {}) =>
        isMobile
          ? `${theme.spacing.padding.medium}px ${theme.spacing.padding.small}px`
          : cardsCount === 1
          ? `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px ${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`
          : `${theme.spacing.padding.small}px 0px ${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
      '&, & *, & *:before, & *:after': {
        fontFamily: theme?.typography?.fontFamily,
        boxSizing: 'border-box'
      }
      // '& h2,& h3': {
      //   fontWeight: '500',
      //   '& b,& strong': {
      //     fontWeight: '700'
      //   }
      // }
    },
    sectionContainer: {
      margin: '0 auto',
      maxWidth: ({ containerWidth } = {}) => containerWidth
    },
    cardHeading: {
      color: theme?.palette?.font?.default,
      fontSize: theme.typography.fontSize.subHead,
      letterSpacing: '3px',
      wordBreak: 'break-word',
      textTransform: 'uppercase',
      textAlign: ({ cardsCount, isMobile }) =>
        cardsCount === 1 || isMobile ? 'center' : 'left'
    },

    // sliderContainer: {
    //   marginRight: '-70px'
    // },
    cursorPointer: {
      cursor: 'pointer'
    },

    singleCard: {
      borderRadius: '24px',
      margin: '0 1px',
      width: 'calc(100% - 24px)',
      position: 'relative',
      paddingBottom: '59.83%' // keeping aspect ratio 585x350
    },
    contentRow: {
      display: 'grid',
      gridTemplateColumns: ({ slidesToShow, cardsCount } = {}) => {
        if (cardsCount === 1) return '';
        return `repeat(${slidesToShow},minmax(0, 1fr))`;
      },
      padding: ({ cardsCount }) => (cardsCount === 1 ? '0px 150px' : '')
    },

    carouselImage: {
      height: ({ cardsCount }) => (cardsCount === 1 ? '480px' : '100%'),
      borderRadius: '24px',
      objectFit: 'cover',
      objectPosition: 'center',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%'
    },

    title: {
      fontSize: theme.typography.fontSize.h2,
      textAlign: ({ cardsCount, isMobile }) =>
        cardsCount === 1 || isMobile ? 'center' : 'left',
      lineHeight: '70px',
      letterSpacing: '-3px',
      color: theme?.palette?.font?.default,
      marginTop: '0px',
      marginBottom: theme.spacing.margin.tiny,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },

    '@media (max-width: 768px)': {
      title: {
        lineHeight: '36px',
        letterSpacing: '-1px',
        color: theme?.palette?.font?.default,
        margin: '4px 0 20px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      },
      contentRow: {
        width: '100%',
        padding: ({ cardsCount }) => (cardsCount === 1 ? '0px' : '')
      },
      carouselImage: {
        height: ({ cardsCount }) => (cardsCount === 1 ? '360px' : ''),
        borderRadius: '16px'
      },
      singleCard: {
        width: ({ cardsCount }) =>
          cardsCount === 1 ? '100%' : 'calc(100% - 16px)'
      }
    }
  };
});

export default usePhotoGalleryStyles;
